module.exports = __webpack_public_path__ + "static/media/admin1.128a273b.jpg";